const ItemNumber = ({ number }) => {
  return <span className='text-sm text-primary-700 font-semibold'>{`0${number}`}</span>
}

export default ItemNumber
